import React from 'react'
import moment from 'moment'

import './DateMeta.scss'

export default function DateMeta({ prefix, by, on, dateFormat='DD/MM/YY [at] h:mm a' }) {	
	var meta = '';
	meta += by && by.label ? ` by ${by.label}` : '';
	meta += on ? ` on ${moment(on).format(dateFormat)}` : '';

	return meta.length
		?	<div className="DateMeta">{prefix}{meta}</div>
		: '';
}


// WEBPACK FOOTER //
// ./src/components/DateMeta/DateMeta.jsx